export const PromotionDiscountTypes = {
  ABSOLUTE: "absolute",
  PERCENTAGE: "percentage",
};

export type PromotionDiscountType =
  typeof PromotionDiscountTypes[keyof typeof PromotionDiscountTypes];
